import { NamingConfig } from '@shared/naming/naming-config';

export type JobRunStats = {
  created?: number;
  updated?: number;
  deleted?: number;
  failed?: number;
};

export type JobRun = {
  runId: string;
  configId: string;
  configName: string;
  lastJobRunAt: string;
  finishedAt?: string | null;
  durationSeconds?: number | null;
  status?: string | null;
  stats?: JobRunStats | null;
  pullRetryCount: number;
  errorMessage?: string | null;
};

export const JobRunNaming = NamingConfig<JobRun>({
  key: 'JobRun',
  modelName: { '=1': $localize`Job Run`, other: $localize`Job Runs` },
  fieldNames: {
    runId: $localize`Run ID`,
    configId: $localize`Config ID`,
    configName: $localize`Config Name`,
    lastJobRunAt: $localize`Last Job Run At`,
    finishedAt: $localize`Finished At`,
    durationSeconds: $localize`Duration`,
    status: $localize`Status`,
    stats: $localize`Stats`,
    pullRetryCount: $localize`Pull Retries`,
    errorMessage: $localize`Error`,
  },
});
